import { render, staticRenderFns } from "./DefaultList.vue?vue&type=template&id=3c00ff29&scoped=true&"
import script from "./DefaultList.vue?vue&type=script&lang=js&"
export * from "./DefaultList.vue?vue&type=script&lang=js&"
import style0 from "./DefaultList.vue?vue&type=style&index=0&id=3c00ff29&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c00ff29",
  null
  
)

export default component.exports